module.exports = __webpack_public_path__ + "img/svg/fire.b5d0691c0ccf40190f384e9b60842ec8.svg";